import { useNavigate } from "react-router-dom";
import styles from "../assets/css/AddQuestion.module.css";
import { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../constants/constants";

const AddQuestion = ({ onClose }) => {
  const [answer, setAnswer] = useState("");
  const [question, setQuestion] = useState("");
  const [type, setType] = useState("1"); 
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const handleQuestionCreate = (e) => {
    e.preventDefault();
    if (question.trim() === "" || answer.trim() === "") {
      alert("Заполните оба поля");
      return;
    }

    const body = {
      answer,
      question,
      type: Number(type),
      lang: "ru",
    };

    axios
      .post(`${BASE_URL}/v0/faq`, body, { headers })
      .then((response) => {
        console.log(response);
        onClose();
        navigate("/FAQ");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleCancel = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <div className={styles.modal}>
      <form onSubmit={handleQuestionCreate} className={styles.container}>
        <div className={styles.box}>
          <div className={styles.text}>Добавить</div>
          <img
            onClick={handleCancel}
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
          />
        </div>
        <input
          onChange={(event) => setQuestion(event.target.value)}
          className={styles.input}
          value={question}
          placeholder="Введите вопрос"
          type="text"
          maxLength="100"
        />
        <input
          onChange={(event) => setAnswer(event.target.value)}
          className={styles.input}
          value={answer}
          placeholder="Введите ответ"
          type="text"
          maxLength="150"
        />
        <div className={styles.selectWrapper}>
          <label className={styles.selectLabel} htmlFor="type-select">
            Выберите тип:
            <select
              className={styles.select}
              id="type-select"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="1">FAQ для пользователей</option>
              <option value="2">FAQ для водителей</option>
            </select>
          </label>
        </div>
        <div className={styles.box1}>
          <button type="submit" className={styles.addbtn}>
            Добавить
          </button>
          <button
            type="button"
            onClick={handleCancel}
            className={styles.cancelbtn}
          >
            Отмена
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddQuestion;
